import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-school-level.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParSchoolLevelDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parSchoolLevelEntity = useAppSelector(state => state.parSchoolLevel.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parSchoolLevelDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.detail.title">ParSchoolLevel</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parSchoolLevelEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.code">Code</Translate>
            </span>
          </dt>
          <dd>{parSchoolLevelEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.name">Name</Translate>
            </span>
          </dt>
          <dd>{parSchoolLevelEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parSchoolLevelEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parSchoolLevelEntity.nameEn}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.type">Type</Translate>
            </span>
          </dt>
          <dd>{parSchoolLevelEntity.type}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolLevel.status">Status</Translate>
            </span>
          </dt>
          <dd>{parSchoolLevelEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-school-level" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-school-level/${parSchoolLevelEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParSchoolLevelDetail;
